import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';

import {
  getRetailUrl,
  userAssetsQueryParams,
  userProgramQueryParams,
} from './constants';
import { Asset, Program } from './types';

export const retailApi = createApi({
  reducerPath: 'retail',
  baseQuery: baseQuery(getRetailUrl),
  endpoints: (builder) => ({
    getUserAssets: builder.query<Asset[], string>({
      query: (teacherBk) =>
        `v1/users/${teacherBk}/assets?${userAssetsQueryParams}`,
    }),
    getUserPrograms: builder.query<Program[], string>({
      query: (teacherBk) =>
        `v1/users/${teacherBk}/programs?${userProgramQueryParams}`,
    }),
  }),
});

export const { useGetUserAssetsQuery, useGetUserProgramsQuery } = retailApi;
